module.exports = __webpack_public_path__ + "static/media/19-10.9fad64ac.mp3";